import React, { useEffect, useState, useRef } from "react";
import Helper from "../functions/Helper.js";
import { Swiper, SwiperSlide } from "swiper/react";

import LikeButton from "./LikeButton.js";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../actions/Actions.js";
import { useStyleData } from "../hooks/useStyleData.js";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Overlay from "react-bootstrap/Overlay";
import DealRow from "../components/DealRow.js";
import Gallery from "../components/Gallery.js";

function StyleModal(props) {
  const ref = useRef(null);
  const [swiper, updateSwiper] = useState(null);
  window.swiper = swiper;
  const [activeStyle, fetchingStatus, updateLikeCounter] = useStyleData(
    props.activeStyle.style_id,
    props.fetchData,
    props.activeStyle
  );
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const onLikeCounterChange = (change) => {
    props.onLikeCounterChange(activeStyle.style_id, change);
    if (props.fetchData) {
      updateLikeCounter(change);
    }
  };
  const [activeSlide, setActiveSlide] = useState(0);
  const [showGallery, setShowGallery] = useState(false);

  useEffect(() => {
    if (activeStyle.pictures?.length > 0) {
      swiper.lazy.load();
    }
  }, [activeStyle.pictures]);

  return (
    <>
      {activeStyle.pictures && (
        <Gallery
          activeSlide={activeSlide}
          setActiveSlide={setActiveSlide}
          showGallery={showGallery}
          closeGallery={() => {
            setShowGallery(false);
          }}
          pictures={activeStyle.pictures.map((x) => ({ ...x, master: x.url }))}
        />
      )}
      <div className="hover-swiper" css={{ width: "100%", height: "100%" }}>
        <div style={{ padding: 0, backgroundColor: "#f9f9f9", width: "100%" }}>
          <Swiper
            onActiveIndexChange={(x) => {
              setActiveSlide(x.activeIndex);
            }}
            watchOverflow={true}
            lazy={{ loadPrevNext: true }}
            observer={true}
            observeParents={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            spaceBetween={50}
            onSwiper={updateSwiper}
            pagination={{ clickable: false }}
          >
            <SwiperSlide>
              <div
                css={{
                  padding: "20px 20px 50px",
                  "@media only screen and (min-width: 576px)": {
                    paddingLeft: 50,
                    paddingRight: 50,
                  },
                }}
              >
                <div
                  style={{
                    width: "100%",
                    paddingBottom: "65%",
                    position: "relative",
                  }}
                >
                  <picture>
                    <source
                      type="image/webp"
                      srcSet={Helper.create_source_set(
                        {
                          master: props.activeStyle.picture_url,
                          thumbnails: "1",
                        },
                        undefined,
                        "webp"
                      )}
                      sizes="(max-width:576px) 500px, 585px"
                    />
                    <source
                      type="image/png"
                      srcSet={Helper.create_source_set({
                        master: props.activeStyle.picture_url,
                        thumbnails: "1",
                      })}
                      sizes="(max-width:576px) 500px, 585px"
                    />
                    <img
                      onClick={() => {
                        setShowGallery(true);
                      }}
                      title={props.activeStyle.name}
                      width={props.activeStyle.width}
                      height={props.activeStyle.height}
                      className="swiper-lazy"
                      css={{
                        cursor: "zoom-in",
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        left: 0,
                        height: "100%",
                        objectPosition: "bottom",
                        width: "100%",
                        transform:
                          props.activeStyle.mirror === "1" ? "scaleX(-1)" : "",
                        objectFit: "contain",
                      }}
                      alt={props.activeStyle.name}
                      sizes="(max-width:576px) 500px, 585px"
                      srcSet={Helper.create_source_set({
                        master: props.activeStyle.picture_url,
                        thumbnails: "1",
                      })}
                    />
                  </picture>
                </div>
              </div>
              <div className="swiper-lazy-preloader"></div>
            </SwiperSlide>
            {(activeStyle.pictures ? activeStyle.pictures.slice(1) : []).map(
              (picture, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      key={index}
                      css={{
                        padding: "20px 20px 50px",
                        "@media only screen and (min-width: 576px)": {
                          paddingLeft: 50,
                          paddingRight: 50,
                        },
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          paddingBottom: "65%",
                          position: "relative",
                        }}
                      >
                        <picture>
                          <source
                            type="image/webp"
                            data-srcset={Helper.create_source_set(
                              { master: picture.url, thumbnails: "1" },
                              undefined,
                              "webp"
                            )}
                            sizes="(max-width:576px) 500px, 585px"
                          />
                          <source
                            type="image/png"
                            data-srcset={Helper.create_source_set({
                              master: picture.url,
                              thumbnails: "1",
                            })}
                            sizes="(max-width:576px) 500px, 585px"
                          />
                          <img
                            onClick={() => {
                              setShowGallery(true);
                            }}
                            title={activeStyle.name}
                            width={activeStyle.width}
                            height={activeStyle.height}
                            className="swiper-lazy"
                            css={{
                              cursor: "zoom-in",
                              position: "absolute",
                              bottom: 0,
                              maxHeight: "90%",
                              right: 0,
                              left: 0,
                              height: "100%",
                              objectPosition: "bottom",
                              width: "100%",
                              transform:
                                picture.mirror === "1" ? "scaleX(-1)" : "",
                              objectFit: "contain",
                            }}
                            alt={activeStyle.name}
                            sizes="(max-width:576px) 500px, 585px"
                            data-srcset={Helper.create_source_set({
                              master: picture.url,
                              thumbnails: "1",
                            })}
                          />
                        </picture>
                      </div>
                    </div>
                    <div className="swiper-lazy-preloader"></div>
                  </SwiperSlide>
                );
              }
            )}
            <div className="swiper-button-next next-button-hover" />
            <div className="swiper-button-prev prev-button-hover" />
          </Swiper>
          <button
            className="close"
            onClick={() => {
              props.hideModal();
            }}
            style={{
              padding: "10px 25px 25px 25px",
              fontSize: 50,
              lineHeight: 1,
              color: "#000",
              position: "absolute",
              zIndex: 1000,
              right: 0,
              top: 0,
            }}
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span>&times;</span>
          </button>
        </div>

        <div>
          {fetchingStatus === "LOADED" && (
            <div
              style={{
                maxWidth: 550,
                margin: "auto",
                padding: "20px 20px 50px",
              }}
            >
              <div style={{ display: "flex", marginBottom: 20 }}>
                <div
                  style={{ display: "flex", flex: 1, flexDirection: "column" }}
                >
                  <Link
                    style={{}}
                    to={
                      "/shoe-reviews/" +
                      activeStyle.shoe_url.toLowerCase() +
                      "/"
                    }
                  >
                    <div
                      style={{
                        fontSize: 22,
                        fontWeight: "600",
                        color: "#000000",
                        lineHeight: 1.3,
                      }}
                    >
                      {activeStyle.shoe_name.toUpperCase()}
                    </div>
                  </Link>
                  <div style={{ fontSize: 16, lineHeight: 1.2, marginTop: 5 }}>
                    {activeStyle.name}
                  </div>
                  <div style={{ fontSize: 16, lineHeight: 1.2, marginTop: 5 }}>
                    #{activeStyle.sku}
                  </div>
                </div>
                <div style={{ marginTop: 0, textAlign: "center" }}>
                  <CopyToClipboard
                    onCopy={() => {
                      setTimeout(() => setShowCopiedMessage(false), 1000);
                      setShowCopiedMessage(true);
                    }}
                    text={
                      __server__ +
                      "/shoe-reviews/" +
                      activeStyle.shoe_url +
                      "/?style_id=" +
                      activeStyle.style_id
                    }
                  >
                    <i
                      ref={ref}
                      title="Click to copy link to this url"
                      style={{
                        cursor: "pointer",
                        padding: "5px 10px",
                        fontSize: 25,
                        color: "#999999",
                      }}
                      className={"far fa-copy"}
                    />
                  </CopyToClipboard>
                  <Overlay
                    target={ref.current}
                    show={showCopiedMessage}
                    placement="bottom-end"
                  >
                    {({
                      placement,
                      arrowProps,
                      show: _show,
                      popper,
                      ...props
                    }) => (
                      <div
                        {...props}
                        style={{
                          top: 10,
                          backgroundColor: "var(--primary-color-600)",
                          padding: "4px 10px",
                          color: "white",
                          fontSize: 14,
                          borderRadius: 3,
                          zIndex: 100000,
                          ...props.style,
                        }}
                      >
                        Copied Link to Clipboard
                      </div>
                    )}
                  </Overlay>
                </div>

                <div
                  style={{
                    marginTop: 0,
                    marginRight: -10,
                    textAlign: "center",
                  }}
                >
                  <LikeButton
                    onLikeCounterChange={onLikeCounterChange}
                    style={{ fontSize: 25 }}
                    style_id={activeStyle.style_id}
                    shoe_id={activeStyle.shoe_id}
                  />
                  <div
                    css={{
                      fontSize: 12,
                      "@media (min-width:414px)": {
                        fontSize: 14,
                        margin: "-5px 10px",
                        marginTop: -5,
                      },
                    }}
                  >
                    {activeStyle.likes} likes
                  </div>
                </div>
              </div>

              {activeStyle.colorways?.length > 0 && (
                <React.Fragment>
                  {activeStyle.colorways.map((colorway, index) => (
                    <DealRow
                      key={index}
                      style={{ borderTopWidth: index === 0 ? 0 : 1 }}
                      trackingId={props.linkId + "_modal"}
                      colorway={colorway}
                    />
                  ))}
                </React.Fragment>
              )}

              {activeStyle.resells?.length > 0 && (
                <React.Fragment>
                  {activeStyle.resells?.map((colorway, index) => {
                    return (
                      <DealRow
                        key={index}
                        style={{ borderTopWidth: index === 0 ? 0 : 1 }}
                        trackingId={props.linkId + "_modal"}
                        colorway={colorway}
                      />

                      /*
                    <div style={{display:"flex",flex:1,flexDirection:"row",padding:"8px 0px",borderTopWidth:1,borderColor:"#f0f0f0",borderStyle:"solid"}} key={colorway.colorway_id} >
                      <div style={{display:"flex",flexDirection:"column",justifyContent:"center"}}>
                        <div>
                          <div style={{color:"#333333",fontSize:16,lineHeight:1.3,fontWeight:500}}>
                          {colorway.shop_name.toUpperCase()}
                          </div>
                        </div>
                        <div style={{display:"flex",alignItems:"flex-end",lineHeight:"22px",flexDirection:"row"}}>
                          <div style={{fontSize:14}}>from&nbsp;</div>
                          <a href={Helper.insert_link(colorway.link_url, props.linkId + "_modal_price",colorway.tracking_id)}>
                            <div style={{fontWeight:"600",fontSize:16,color:"black"}}>
                            ${colorway.price_discount}
                            </div>
                          </a>
                        </div>
                      </div>
                      <div style={{display:"flex",flexDirection:"column",flex:1,justifyContent:"center",alignItems:"flex-end"}}>
                        <a target="_blank" rel="noopener nofollow" href={Helper.insert_link(colorway.link_url, props.linkId + "_modal_button",colorway.tracking_id)}
                          css={{":hover":{textDecoration:"none",color:"white"},color:"white",fontWeight:"600",borderRadius:2,padding:"8px 30px",fontSize:14,backgroundColor:"#FF5A5F",}}>
                          Buy Now
                        </a>
                      </div>
                  </div>*/
                    );
                  })}
                </React.Fragment>
              )}
              {activeStyle.colorways?.length === 0 &&
                activeStyle.resells?.length === 0 && (
                  <div style={{ paddingTop: 20 }}>
                    <div style={{ color: "#767676" }}>No stores found</div>
                  </div>
                )}
              <div style={{ marginTop: 30, fontSize: 12 }}>
                Support thehoopsgeek.com by clicking and buying from our partner
                shops. We get a small commission for every purchase we refer at
                no additional cost to you!
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

StyleModal.defaultProps = {
  fetchData: false,
  onLikeCounterChange: () => {},
};

StyleModal.propTypes = {
  linkId: PropTypes.string.isRequired,
  activeStyle: PropTypes.object.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default connect(
  (state) => ({
    data: state.data.data,
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(StyleModal);
